import { useLocation } from 'react-router-dom';
import icon from '../assets/images/done.svg';
export default function Done(params) {
  const { state } = useLocation();
  return (
    <div className="h-screen w-full bg-gray-200 flex justify-center items-center flex-col">
      <img className="w-32 mb-10" src={icon} alt="" />
      <h1 className="font-bold">تم التقديم بنجاح</h1>
      <p className="mt-10 text-gray-500">
        تم التقديم بنجاح و سيتم التواصل معكم لاطلاعكم على نتيجة التقديم
      </p>{' '}
      <p className="mt-10 text-gray-500">
        نأمل العمل سوية لإنجاح المشروع الإستراتيجي مشروع الكابل الضوئي في جانب الكرخ{' '}
      </p>{' '}
    </div>
  );
}
